import types from '@/actions/types';
import useContent from '@/composables/useContent';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class Navigation extends Base {
  constructor(params) {
    super(params, types.NAVIGATION);
    const { getById } = useContent();
    this.analyticData.elementType = getById(params.uuid).type;
  }

  async execute() {
    const { setCurrentContent, contentPromise } = useContent();
    const { trackAction } = useAnalytics();
    trackAction(this);

    // we need to wait until video of previous slide is finished before navigate
    if (contentPromise.value) {
      await contentPromise.value;
    }

    return new Promise((resolve) => {
      this.resolve = resolve;
      const { uuid } = this.params;
      setCurrentContent(uuid);
      resolve();
    });
  }

  stop() {
    if (this.resolve) {
      this.resolve();
    }
  }
}
